(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mp-engraving"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mp-engraving')) {
    // Letters, numbers, spaces and simple punctuation; anything else cannot be engraved.
    var MP_ENGRAVE_BAD = /[^A-Za-z0-9 .,'!?\-]/g;

    customElements.define('mp-engraving', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.toggleBtn = this.querySelector('.mp-engrave__toggle');
        this.panel = this.querySelector('.mp-engrave__panel');
        this.inputs = Array.from(this.querySelectorAll('.mp-engrave__input'));
        this.check = this.querySelector('.mp-engrave__check');
        this.sub = this.querySelector('[data-sub]');
        this.warn = this.querySelector('[data-warn]');
        this.etch = Array.from(this.querySelectorAll('[data-etch]'));
        this.hint = this.querySelector('[data-etch-hint]');

        this.toggleBtn.addEventListener('click', () => this.setOpen(!this.open));
        this.querySelector('[data-remove]').addEventListener('click', () => this.clear());
        this.inputs.forEach((input, i) => {
          input.addEventListener('input', () => this.onInput(input));
          input.addEventListener('blur', () => {
            input.value = input.value.replace(/\s+/g, ' ').trim();
            this.sync();
          });
          input.addEventListener('keydown', (e) => {
            if (e.key !== 'Enter') return;
            e.preventDefault();
            var next = this.inputs[i + 1];
            if (next) next.focus(); else input.blur();
          });
        });
        // A required checkbox inside a collapsed panel cannot show its message: open it first.
        this.check.addEventListener('invalid', () => this.setOpen(true));
        // Values restored by the browser (back/forward cache) still need names and the preview.
        window.addEventListener('pageshow', () => this.sync());
        this.sync();
        if (this.hasText()) this.setOpen(true);
        var fitLabel = () => this.querySelectorAll('[data-fit]').forEach((t) => this.fit(t, Number(t.dataset.fit)));
        fitLabel();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitLabel);
        this.toggleBtn.addEventListener('click', () => setTimeout(fitLabel, 60));
      }

      get open() {
        return this.hasAttribute('data-open');
      }

      setOpen(open) {
        this.toggleAttribute('data-open', open);
        this.toggleBtn.setAttribute('aria-expanded', String(open));
        this.panel.inert = !open;
        if (open && !this.hasText()) {
          setTimeout(() => this.inputs[0] && this.inputs[0].focus({ preventScroll: true }), 120);
        }
      }

      hasText() {
        return this.inputs.some((i) => i.value.trim() !== '');
      }

      onInput(input) {
        var before = input.value;
        var cleaned = before.replace(/[‘’]/g, "'").replace(MP_ENGRAVE_BAD, '');
        if (cleaned !== before) {
          var pos = Math.max(0, (input.selectionStart || cleaned.length) - (before.length - cleaned.length));
          input.value = cleaned;
          try { input.setSelectionRange(pos, pos); } catch (e) {}
          this.flash('Special characters and symbols cannot be engraved.');
        }
        this.sync();
      }

      flash(msg) {
        this.warn.textContent = msg;
        clearTimeout(this._warnT);
        this._warnT = setTimeout(() => { this.warn.textContent = ''; }, 3200);
      }

      clear() {
        this.inputs.forEach((i) => { i.value = ''; });
        this.check.checked = false;
        this.sync();
        this.setOpen(false);
        this.toggleBtn.focus();
      }

      sync() {
        var any = false;
        var parts = [];
        this.inputs.forEach((input, idx) => {
          var v = input.value;
          var has = v.trim() !== '';
          if (has) { input.setAttribute('name', input.dataset.name); any = true; parts.push(v.trim()); }
          else input.removeAttribute('name');
          var counter = input.parentElement.querySelector('[data-count]');
          if (counter) counter.textContent = v.length;
          var t = this.etch[idx];
          if (t) { t.textContent = v; this.fit(t, 88); }
        });
        this.hint.style.display = any ? 'none' : '';
        this.check.disabled = !any;
        this.check.required = any;
        if (any) this.check.setAttribute('name', this.check.dataset.name);
        else this.check.removeAttribute('name');
        this.toggleAttribute('data-active', any);
        this.sub.textContent = any ? '“' + parts.join(' / ') + '”' : this.sub.dataset.default;

        // Accelerated checkout buttons bypass the form's validation, so hide them while engraving.
        var form = document.getElementById(this.dataset.form);
        var accel = form && form.querySelector('.accelerated-checkout-block');
        if (accel) accel.style.display = any ? 'none' : '';
      }

      fit(t, max) {
        max = max || 112;
        t.removeAttribute('textLength');
        t.removeAttribute('lengthAdjust');
        try {
          if (t.getComputedTextLength() > max) {
            t.setAttribute('textLength', String(max));
            t.setAttribute('lengthAdjust', 'spacingAndGlyphs');
          }
        } catch (e) {}
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mp-scent-picker"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-mp-scent]').forEach(function (root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var list = root.querySelector('datalist');
    var inputs = root.querySelectorAll('.mp-scent__input');
    var loaded = null;
    function load() {
      if (loaded) return loaded;
      loaded = fetch(root.dataset.src)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var frag = document.createDocumentFragment();
          d.rows
            .filter(function (r) { return r[2]; })
            .sort(function (a, b) { return a[1].localeCompare(b[1]); })
            .forEach(function (r) {
              var o = document.createElement('option');
              o.value = r[1];
              o.label = 'Inspired by ' + r[2] + ' · ' + r[3];
              frag.appendChild(o);
            });
          list.appendChild(frag);
        })
        .catch(function () {});
      return loaded;
    }
    inputs.forEach(function (i) {
      i.addEventListener('focus', load, { once: true });
      i.addEventListener('pointerenter', load, { once: true });
    });
    // If the page is already interactive, warm the list in the background.
    if ('requestIdleCallback' in window) requestIdleCallback(load); else setTimeout(load, 1500);
  });
  } catch(e) { console.error(e); }
})();

})();
